@if (hasPrev|| hasNext) {
  <mat-toolbar>
    @if (hasPrev) {
      <button mat-button (click)="emitPrev()"><mat-icon>chevron_left</mat-icon>{{ prevLabel }}</button>
    }
    @if (hasNext) {
      <button mat-button (click)="emitNext()">{{ nextLabel }} <mat-icon>chevron_right</mat-icon></button>
    }
    @if (showDirectPagination && (hasPrev || currentPage !== 0)) {
      <form
        class="direct-pagination"
        fxLayout="row"
        fxLayoutGap="20px"
        (submit)="emitDirectPagination(directInput.value)"
        >
        <mat-form-field subscriptSizing="dynamic">
          <input matInput type="number" #directInput [value]="currentPage">
        </mat-form-field>
        <button mat-button>Ga</button>
      </form>
    }
  </mat-toolbar>
}